<template>
  <collapse-transition :appear="appear">
    <ul :class="classes">
      <li>
        <!--展开收的箭头-->
        <div :class="titleWrapperClasses">
          <span :class="arrowClasses" @click="handleExpand">
            <Icon v-if="showArrow" type="md-arrow-dropright" />
            <Icon v-if="showLoading" type="ios-loading" class="ivu-load-loop" />
          </span>
          <Checkbox v-if="showCheckbox && multiple && isCheck" :value="data.checked" @click.native.prevent="handleCheck"></Checkbox>
          <span :class="titleClasses" @click="handleSelect">{{
            data.title
          }}</span>
          <Dropdown v-if="multiple && children" trigger="click" @on-click="onDropClick" class="uf-tree-more" placement="bottom-end">
            <a href="javascript:void(0)">
              <Icon type="ios-more" style="font-size: 25px;"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem :name="checkAllChildrenAndSelf">全选</DropdownItem>
              <DropdownItem :name="checkFirstChildren">选中直属下级</DropdownItem>
              <DropdownItem :name="checkAllChildren">选中所有下级</DropdownItem>
              <DropdownItem :name="cancel">取消选择</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <Radio v-if="!multiple && isCheck" :value="data.checked" @on-change="radioOnChange" style="float:right;" >
            <span style="display: none;">{{data.nodeKey}} + {{data.checked}}</span>
          </Radio>
        </div>
        <template v-if="data.expand">
          <tree-node
            :show-checkbox="showCheckbox"
            v-for="(item) in children"
            :data="item"
            :multiple="multiple"
            :is-check="item.isCheck"
            :appear="appearByClickArrow"
            :key="item.nodeKey"
          ></tree-node>
        </template>
      </li>
    </ul>
  </collapse-transition>
</template>

<script>
import CollapseTransition from "@/components/base/collapse-transition.js";
import Emitter from "../../mixins/emitter";
import { findComponentUpward } from "@/utils/dom.js"
const prefixCls = "uf-tree";
export default {
  name: "treeNode",
  mixins: [Emitter],
  mounted() {
    // console.log(this.data.expand);
  },
  props: {
    showCheckbox: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    childrenKey: {
      type: String,
      default: "children"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    appear: {
      type: Boolean,
      default: false
    },
    isCheck: { //是否可以被选中
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleSelect() {},
    handleExpand() {
      const item = this.data;
      //展开收起箭头的点击
      this.appearByClickArrow = true;
      if (item[this.childrenKey].length === 0) {
        const tree = findComponentUpward(this, "tree");
        // console.log(tree);
        if (tree && tree.loadData) {
          this.$set(this.data, "loading", true);
          tree.loadData(item, children => {
            this.$set(this.data, "loading", false);
            if (children.length) {
              this.$set(this.data, this.childrenKey, children);
              this.$nextTick(() => this.handleExpand());
            }
          });
          return;
        }
      }

      this.$set(this.data, "expand", !this.data.expand);
    },
    onDropClick(item) {
      const changes = {
        checked: true,
        nodeKey: this.data.nodeKey
      };
      if (item === this.checkAllChildrenAndSelf) {
        this.dispatch("tree", "on-all-check", changes);
      }
      if (item === this.cancel) {
        this.dispatch("tree", "cancel", {
          checked: false,
          nodeKey: this.data.nodeKey
        });
      }
      if (item === this.checkAllChildren) {
        this.dispatch("tree", "checkAllChildren", changes);
      }
      if (item === this.checkFirstChildren) {
        this.dispatch("tree", "checkFirstChildren", changes);
      }
      // this.dispatch("tree", "on-node-change");
    },
    radioOnChange() {
      // console.log(val);
      this.dispatch("tree", "on-radio", {
        checked: true,
        nodeKey: this.data.nodeKey
      });
    },
    handleCheck() {
      let changes = {
        checked: !this.data.checked,
        nodeKey: this.data.nodeKey
      };
      this.dispatch("tree", "on-check", changes);
    }
  },
  data() {
    return {
      appearByClickArrow: false,
      checkAllChildrenAndSelf: "1",
      checkFirstChildren: "2",
      checkAllChildren: "3",
      cancel: "4"
    };
  },
  components: {
    CollapseTransition
  },
  computed: {
    classes() {
      return [`${prefixCls}-children`, `${prefixCls}-ul`];
    },
    arrowClasses() {
      return [
        `${prefixCls}-arrow`,
        {
          [`${prefixCls}-arrow-open`]: this.data.expand
        }
      ];
    },
    titleClasses() {
      return [`${prefixCls}-title`];
    },
    titleWrapperClasses() {
      return [`${prefixCls}-title-wrapper`];
    },
    children() {
      return this.data["children"];
    },
    showArrow() {
      return (this.data[this.childrenKey] && this.data[this.childrenKey].length) || ('loading' in this.data && !this.data.loading);
    },
    showLoading() {
      return "loading" in this.data && this.data.loading;
    }
  }
};
</script>

<style scoped></style>
